import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../AuthContext";
import Button from "../components/Button";
import { ButtonContainer } from "../components/ButtonContainer";
import CenterContainer from "../components/CenterContainer";
import { AnyListener, useForm } from "typed-react-form";
import { RawFormError, RawFormInput, FormLabel, FormRow, FormText, Form } from "../components/FormElements";
import Title from "../components/Title";
import { UserUpdatePasswordRequest, UserUpdatePasswordRequestSchema } from "consumerhouse-shared";
import { Translation, useLanguage } from "../useLanguage";
import { RateLimitError } from "../api";

export default function ChangePassword() {
    const { client, setAuth, auth } = useContext(AuthContext);
    const history = useHistory();
    const language = useLanguage();
    const form = useForm<UserUpdatePasswordRequest>({ newPassword: "", oldPassword: "" }, (data) => UserUpdatePasswordRequestSchema.validate(data));

    async function submit() {
        await form.validate();
        if (form.error) return;
        form.setState({ isSubmitting: true });
        try {
            let res = await client.fetch("/user/update-password", form.values);
            if (res.status === "error") {
                form.setErrors({
                    newPassword: res.newPassword ? language(res.newPassword as any) : undefined,
                    oldPassword: res.oldPassword ? language(res.oldPassword as any) : undefined,
                });
            } else {
                setAuth(null);
                history.push("/account");
            }
        } catch (ex) {
            if (ex instanceof RateLimitError) {
                form.setError("newPassword", language("change-password-limit"));
            } else {
                console.error("Could not update password", ex);
            }
        }

        form.setState({ isSubmitting: false });
    }

    return (
        <CenterContainer width="500px" style={{ margin: "2em 0" }}>
            <Title>Wachtwoord wijzigen</Title>
            <Form
                onSubmit={(ev) => {
                    ev.preventDefault();
                    submit();
                }}>
                <FormRow>
                    <FormLabel>{language("change-password-old")}</FormLabel>
                    <FormText form={form} type="password" name="oldPassword" />
                </FormRow>
                <FormRow>
                    <FormLabel>{language("change-password-new")}</FormLabel>
                    <FormText form={form} type="password" name="newPassword" />
                </FormRow>
                <hr />
                <ButtonContainer>
                    <Button type="button" color="#666" icon={faTimes} onClick={() => history.push("/account")}>
                        {language("change-password-cancel")}
                    </Button>
                    <AnyListener
                        form={form}
                        render={({ state, error }) => (
                            <Button color="#56a44f" disabled={state.isSubmitting} loading={state.isSubmitting} type="submit" icon={faCheck}>
                                {language("change-password-finish")}
                            </Button>
                        )}
                    />
                </ButtonContainer>
            </Form>
        </CenterContainer>
    );
}
